import { PanelDesignTokens } from '@primeuix/themes/types/panel';

export const PANEL_STYLES: PanelDesignTokens = {
  content: { padding: '0 1rem 1.5rem' },
  header: { padding: '1rem' },
  toggleableHeader: { padding: '1rem' },
  css: () => `
    .p-panel-title {
      font-size: 1.125rem;
    }

    .p-panel-header {
      justify-content: flex-start;
    }`,
};
